import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ChatRequest } from 'src/models/ts/chat-request';
import { ChatResult } from 'src/models/ts/chat-result';
import { AiButtonModel } from '../../../../models/ts/ai-button-model';
import { LicenseKeyType } from '../../../../models/ts/license-key-type.model';
import { AiButtonResponse } from 'src/app/store/features/forms/effects/forms-ai-effects';
import { delay, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AiApiService {

  public constructor(private http: HttpClient) { 

  }

  public chat(request: ChatRequest): Observable<ChatResult> {
    return this.http.post<ChatResult>(`api/ai/chat`, request);
  }

  public chatStream(request: ChatRequest): Observable<string> {
    return this.http.post<string>(`api/ai/chat`, request);
  }

  public autoComplete(aiButton: AiButtonModel): Observable<AiButtonResponse>{
    return this.http.post<AiButtonResponse>(`api/ai/autocomplete/form/${aiButton.FormId}/collection/${aiButton.CollectionsId}/instance/${aiButton.InstancesId}/version/${aiButton.VersionsId}/aiButton/${aiButton.AiButtonId}`, aiButton.Fields);
  }

  public hasAiLicense(licenseKeyType: LicenseKeyType): Observable<boolean> {
    return this.http.get<boolean>(`api/validlicense/${licenseKeyType}`);
  }

  public confirmAiUse(): Observable<void> {
    return this.http.post<void>(`api/ai/management/confirm-first-time-use`, true);
  }
}
